import React from 'react'
import { styled } from '../../../stitches.config';

import { ImageCaption } from './BackgroundImage';
import { withDrawingBoard } from "../../HOCs/withDrawingBoard"
import useMediaQuery from "../../../helpers/useMediaQuery";

const Image = ({ blockData, ...props }) => {
    //const srcUrl = blockData.url;
    const isDesktop = useMediaQuery('bp4');
    const windowWidth = window.innerWidth;
    const srcUrlMobile = blockData.url.replace("0,0,0,0", `${windowWidth * 2},0,0,0`)
    const srcUrlDesktop = blockData.url.replace("0,0,0,0", `${840 * 2},0,0,0`)

    return (<BizonImageWrapper>
        <img src={isDesktop ? srcUrlDesktop : srcUrlMobile} alt="" onLoad={() => props.updateHeight()} />
        {blockData.imageCaption !== "" && <ImageCaption className="image-caption">{blockData.imageCaption}</ImageCaption>}
    </BizonImageWrapper>
    )
}

const BizonImageWrapper = styled("div", {
    width: "100%",
    margin: "40px auto 32px auto",
    img: {
        width: "100%",
        height: "auto"
    },
    "@bp4": {
        width: "840px",
        margin: "88px auto 80px auto"
    },
    ".image-caption": {
        marginTop: "8px",
        fontStyle: "normal",
        textAlign: "center",
        color: "#8d8d8d",
        fontSize: "14px",
        lineHeight: "18px",
        fontFamily: "$grotesk",
        "@bp4": {
            marginTop: "12px"
        }
    }
});

export default withDrawingBoard(props => props.blockData.hasCanvas)(Image);